import React from "react";
import MainLayout from "../../Partials/MainLayout";
import FeedLayout from "../../Partials/FeedLayout";
import CreatePost from "./CreatePost";

const CreatePostPage = () => {
    return (
        <MainLayout>
            <FeedLayout>
                <CreatePost />
            </FeedLayout>
        </MainLayout>
    );
};

export default CreatePostPage;
